import { combineReducers } from 'redux';
import commentReport from 'store/reducers/commentReport/commentReport';
import commentReportFilters from 'store/reducers/commentReport/commentReportFilters';
import commentReportExcel from 'store/reducers/commentReport/commentReportExcel';

export default combineReducers({
  commentReport,
  commentReportFilters,
  commentReportExcel
});